import { lazy } from 'react';

const Help = lazy(() => import('./help/help'));
const Dashboard = lazy(() => import('./promotion/promotion'));
const TimeBased = lazy(() => import('./lead/lead'));
const SpecialPromotion = lazy(() => import('./specialPromotion/specialPromotion'));
const Administration = lazy(() => import('./administration/administration'));
const PromotionBoard = lazy(() => import('./promotionBoard/promotionBoard'));
const FunctionalLead = lazy(() => import('./functionalLead/functionalLead'));
const StandardPromotion = lazy(() => import('./standardPromotion/standardPromotion'));
const LeadEmployeeHistory = lazy(() => import('./leadEmployeeHistory/leadEmployeeHistory'));
const CycleHistory = lazy(() => import('./promotionCycleHistory/promotionCycleHistory'));

export const View = {
  Dashboard,
  TimeBased,
  SpecialPromotion,
  LeadEmployeeHistory,
  Administration,
  PromotionBoard,
  FunctionalLead,
  StandardPromotion,
  CycleHistory,
  Help
};

